<div>
  <app-error-display 
    [control]="inputControl"
    [customErrorMessageProvider]="getTooltipData.bind(this)">
  </app-error-display>
  <label  i18n="Experience product line">Product Group</label>

  <select id="journeyGroup" class="form-control"
    [formControl]="inputControl"
    [infiniteScrollDistance]="scrollDistance"
    [infiniteScrollThrottle]="throttle"
    (change)="productGroupSelected($event.target.value)"
    (scrolled)="onScrollDown()"
    (ngModelChange)="emitChangeEvent($event)"
    data-infinite-scroll
    debounce>


    <option selected value="" [attr.disabled]="inputControl?.dirty ? 'disabled' : null"></option>
    @if (productGroups.length > 1) {
      <option value="all">All Product Groups</option>
    }
    @for (productGroup of productGroups; track productGroup) {
      <option class="form-control" [ngValue]="productGroup.id">
        {{productGroup.internal_name}}
      </option>
    }
  </select>
</div>

<message-dialog></message-dialog>
